<div class="box-input">
    <label v-if="label" :for="label" class="txt-ellipsis">{{label}}</label>
    <input :value="value" @keyup.enter="onEnter" @keypress="isNumber($event)"
        @input="$emit('update:value', $event.target.value)" :type="type?type:'text'" :id="label"
        :placeholder="placeholder" :class="{'outline-danger': isError}" :readonly="readonly" class="input" />
    <p v-if="isError" class="mb0 txt-danger font12 mt3">
        <span v-if="errorMessage">{{errorMessage}}</span>
        <span v-else>{{label}} is required.</span>
    </p>
</div>